import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { DomainObject } from '@logio/common-be-fe';
/**
 * @author VSm
 * @created on Dec 31 2019
 * @copyOf packages/common-be/src/data-processing/model/DpConfig.ts
 */

export var DpConfig =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DpConfig, _DomainObject);

  // tslint:disable-next-line:prettier
  function DpConfig(id, defaults, tasks) {
    var _this;

    _classCallCheck(this, DpConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DpConfig).call(this));
    _this.id = id;
    _this.defaults = defaults;
    _this.tasks = tasks;
    return _this;
  }

  return DpConfig;
}(DomainObject);